<template>
    <div>
        <div class="product-list bbs-primary-color">
            <div class="title">产品圈子</div>
            <div class="list">
                <div class="item" v-for="item in product" :key="item.name">
                    <div class="img-thumb">
                        <img :src="item.src" alt="">
                    </div>
                    <div class="item-title">
                        {{ item.title }}
                    </div>
                    <div class="item-title1">
                        {{ item.title1 }}
                    </div>
                    <div class="item-title2">
                        {{ item.title2 }}
                    </div>
                </div>
            </div>
        </div>
        <div class="sum-list bbs-primary-color user-card">
            <div class="title">
                数据总览
            </div>
            <div class="list">
                <div class="item" v-for="item in sum" :key="item.name">
                    <div class="value">
                        <count-to :startVal='0' :endVal="0" :duration="800"></count-to>
                    </div>
                    <div class="item-title">
                        {{ item.title }}
                    </div>
                </div>
            </div>
        </div>
        <div class="user-card">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
import CountTo from 'vue-count-to';

export default {
    components: {
        CountTo
    },
    data() {
        return {
            product: [
                {title: 'Bigemp Gis Office', icon: 'el-icon-setting',title1:'新GIS行业基础软件',title2:'桌面端(PC端)',src:'/static/bbs/images/product/pro.png', sum: 0, name: 'gis'},
                {title: 'Bigemp SDK', icon: 'el-icon-warning-outline',title1:'离线地图服务器',title2:'WEB端(PC端)',src:'/static/bbs/images/product/sdk.png', sum: 0, name: 'sdk'},
                {title: 'Bigemp APP', icon: 'el-icon-warning-outline',title1:'新GIS行业基础软件',title2:'移动端(Android和IOS)',src:'/static/bbs/images/product/app.png', sum: 0, name: 'app'},
            ],
            sum: [
                {title: '积分', icon: 'el-icon-warning-outline', sum: 0, name: 'coin'},
                // {title: '赞', icon: 'el-icon-setting', sum: 0, name: 'ok'},
                {title: '提问', icon: 'el-icon-warning-outline', sum: 0, name: 'answer'},
                {title: '回答', icon: 'el-icon-warning-outline', sum: 0, name: 'help'},
            ],
        }
    },
    methods: {}
}
</script>
<style scoped lang="less">
.product-list{
    padding: 15px;
    background-color: #fff;
    margin-top: 1.5rem;
    .title {
        font-weight: 600;
    }

    .list {
        display: flex;
        align-items: center;
        padding: 10px 0;
        justify-content: space-around;

        .item {
            .item-title {
                font-size: 22px;
            }
        }
    }

    .item{
        text-align: center;
        border:1px solid #ddd;
        border-radius: 10px;
        padding: 20px;
        box-shadow: 0 1px 1px rgba(97, 108, 121, 0.1), 0 7px 18px 0 rgba(21, 111, 170, 0.21);
        .img-thumb{
            max-width: 220px;
            height: 180px;
            img{
                max-width: 100%;
            }
        }

        .item-title1{
            color: #555;
            padding: 15px 0;
        }
        .item-title2{
            color: #999;
        }
    }
}

.sum-list {
    padding: 15px;
    background-color: #fff;
    margin-top: 1.5rem;

    .title {
        font-weight: 600;
    }

    .list {
        display: flex;
        align-items: center;
        padding: 10px 0;
        justify-content: space-around;

        .item {
            .item-title {
                font-size: 22px;
            }
        }
    }
}

.sum-list{
    .list {
        .item {
            text-align: center;
            .value{
                font-size: 22px;
            }
            .item-title {
                padding-top:10px;
                font-size: 14px;
            }
        }
    }
}
</style>
